// src/components/PrivateRoute.jsx
//
// Ported from the AFSC reference almost unchanged -- it's five lines
// doing one job. The only change is the localStorage key name
// ("access_token", matching api/client.js) instead of AFSC's
// "accessToken", so the whole app uses one consistent naming convention
// instead of two.

import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const accessToken = localStorage.getItem("access_token");
  return accessToken ? children : <Navigate to="/login" />;
}
